import { render } from "./UiDatepicker.vue?vue&type=template&id=31f20302&lang=pug"
import script from "./UiDatepicker.vue?vue&type=script&setup=true&lang=js"
export * from "./UiDatepicker.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__